import { render } from "./Capture.vue?vue&type=template&id=60d7c1a0&scoped=true"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"

import "./Capture.vue?vue&type=style&index=0&id=60d7c1a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d7c1a0"]])

export default __exports__